// src/services/giftService.js
import apiClient from "./apiClient";

const endpoints = { base: "/admin/gift" };

// Backend accepts exactly "Publish" or "UnPublish"
const normalizeStatus = (s) =>
  String(s || "").toLowerCase() === "publish" ? "Publish" : "UnPublish";

// GET: /admin/gift  -> { data: [ { _id, price, status, icon, ... } ] }
export async function getAllGifts({ signal } = {}) {
  const res = await apiClient.get(endpoints.base, { signal });
  return res.data;
}

// POST: /admin/gift  (price, status, icon[file])
export async function addGift({ coin, status, iconFile }, { signal } = {}) {
  const fd = new FormData();
  fd.set("price", String(coin));                 // API field is "price"
  fd.set("status", normalizeStatus(status));
  if (iconFile instanceof File) fd.append("icon", iconFile, iconFile.name);

  const res = await apiClient.post(endpoints.base, fd, { signal });
  return res.data;
}

// PUT (partial): /admin/gift  (id/_id + any of price/status/icon)
// Always use a real PUT. Many backends handle multipart on PUT just fine.
export async function updateGiftPartial(
  { id, coin, status, iconFile },
  { signal } = {}
) {
  const fd = new FormData();
  // send both, to satisfy backends that expect "id" or "_id"
  fd.set("id", id);
  fd.set("_id", id);

  if (typeof coin !== "undefined")   fd.set("price", String(coin));
  if (typeof status !== "undefined") fd.set("status", normalizeStatus(status));
  if (iconFile instanceof File)      fd.append("icon", iconFile, iconFile.name);

  const res = await apiClient.put(endpoints.base, fd, { signal });
  return res.data;
}

// DELETE: /admin/gift (body: { id })
export async function deleteGift({ id }, { signal } = {}) {
  const res = await apiClient.delete(endpoints.base, { signal, data: { id } });
  return res.data;
}
